import { KeyboardEvent } from "react";
import { ReferralImport } from "../../../../models";
import { displayDateAndTime } from "../../../../helper-functions";

interface ReferralImportRowProps {
    referralImport: ReferralImport;
    onClick: () => void;
}

export const ReferralImportRow = ({ referralImport, onClick }: ReferralImportRowProps) => {
    const onKeyDown = (e: KeyboardEvent<HTMLTableRowElement>) => {
        if (e.key === "Enter") {
            onClick();
        }
    };

    return (
        <tr className="referral-row clickable" onClick={onClick} tabIndex={0} onKeyDown={onKeyDown}>
            <td>{referralImport.opoName}</td>
            <td>{referralImport.caseFileIdentifier}</td>
            <td className="text-nowrap fw-bold">
                {referralImport.patientFirstName} {referralImport.patientLastName}
            </td>
            <td>{displayDateAndTime(referralImport.createdOn)}</td>
        </tr>
    );
};
